import { useRef, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { FloatingActionButton } from '../ui/FloatingActionButton'
import { SlidingSidebar } from '../ui/SlidingSidebar'
import { useSidebarLayout } from '../../hooks/useSidebarLayout'
import { ConversationListContext } from '../../contexts/ConversationListContext'

export const SidebarProvider = ({ children }) => {
  const { sidebarOpen, openSidebar, closeSidebar } = useSidebarLayout()
  const conversationListContext = useContext(ConversationListContext)
  const conversationHistoryRef = useRef(null)

  // Register the ref with the context (only if context is available)
  useEffect(() => {
    if (conversationListContext?.setConversationListRef) {
      conversationListContext.setConversationListRef(conversationHistoryRef.current)
    }
  }, [conversationListContext])

  return (
    <>
      {children}
      <FloatingActionButton onClick={openSidebar} />
      <SlidingSidebar
        isOpen={sidebarOpen}
        onClose={closeSidebar}
        conversationHistoryRef={conversationHistoryRef}
      />
    </>
  )
}

SidebarProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SidebarProvider
